export abstract class BaseGroup {
    key: string
    header: string
    constructor(header: string){
        this.header = header
        this.key = header
    }
}